export default {
  sv: {
    contextButtonTitle: 'Diagrammets meny',
    decimalPoint: ',',
    downloadJPEG: 'Ladda ner JPEG',
    downloadPDF: 'Ladda ner PDF',
    downloadPNG: 'Ladda ner PNG',
    downloadSVG: 'Ladda ner SVG',
    loading: 'Laddar...',
    months: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'],
    printChart: 'Skriv ut',
    rangeSelectorFrom: 'Från',
    rangeSelectorTo: 'Till',
    rangeSelectorZoom: 'Zoom',
    resetZoom: 'Återställ zoom',
    resetZoomTitle: 'Återställ zoom till 1:1',
    shortMonths: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    thousandsSep: ' ',
    weekdays: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
  }
};



// WEBPACK FOOTER //
// ./src/i18n/highchartsLocaleData.js